export const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);

export const escapeRegExp = (str) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const replaceAll = (str, find, replace) => str.replace(new RegExp(escapeRegExp(find), 'g'), replace);

export const decodeHtml = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html.replace(/&#8203;/g, '');
    return txt.value;
};

export const getPlaceholder = (element) => {
    return element.getAttribute('placeholder') || '';
};
